export default {"src":"https://cdn.jetlend.ru/_next/static/media/app-store-icon.7cfef4ee.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};